import { createSlice } from "@reduxjs/toolkit";

const NotificationSlice = createSlice({
  name: "notification",
  initialState: {
    loading: false,
    voicemail: [],
    fax: [],
    call: [],
    recording: [],
    conversation: [],
  },
  reducers: {
    setNotifications(state, action) {
      const {call,voicemail,fax,recording,conversation} = action.payload;
      
      return (state = {
        ...state,
        voicemail: voicemail,
        fax: fax,
        call: call,
        recording: recording,
        conversation: conversation,
      });
    },
    // Replaces only the unread SMS conversations; the other types are kept.
    setConversationNotifications(state, action) {
      return {
        ...state,
        conversation: action.payload || [],
      };
    },
    setNotificationsLoading(state, action) {
      return {
        ...state,
        loading: action.payload
      }
    },
  },
});

export const { setNotifications,setConversationNotifications,setNotificationsLoading } = NotificationSlice.actions;
export default NotificationSlice.reducer;
